(() => {
  const init = () => {
    document.querySelectorAll('[data-ccc-announcement-pause]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const slider = button.previousElementSibling;
      if (!slider?.classList.contains('announcement-bar')) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = motion.matches;
      const paint = () => {
        slider.announcementBarArrowButtonWasClicked = paused;
        if (paused) slider.pause(); else slider.play();
        button.textContent = paused ? '▶' : 'Ⅱ';
        button.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
        button.setAttribute('aria-pressed', String(paused));
      };
      paint();
      button.addEventListener('click', () => { paused = !paused; paint(); });
      motion.addEventListener('change', () => { paused = motion.matches; paint(); });
      slider.querySelectorAll('[name="previous"],[name="next"]').forEach(arrow => arrow.addEventListener('click', () => {paused = true; paint();}));
    });
  };
  customElements.whenDefined('slideshow-component').then(init);
})();
